module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00165.fa6df1cd.jpg";